import React, { FunctionComponent, useState } from "react";

/* Validation */
import { Formik, useFormikContext } from "formik";
import validationSchema, { FormData } from "./formConfig";

/* API */
import axios from "axios";
import { Endpoints } from "@internal/common";
import { Button, Flex, Title } from "@gjensidige/builders-components";
import FormAlert from "./components/FormAlert";
import FormInput from "./components/FormInput";

const OrderOfferDIByggeri = () => {
  const [submitted, setSubmitted] = useState(false);
  const [apiError, setApiError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const sendFormData = (formData: FormData) => {
    setApiError(false);
    setIsLoading(true);
    axios
      .post(Endpoints.OrderOfferDIByggeri, formData)
      .then(() => setSubmitted(true))
      .catch(() => {
        setIsLoading(false);
        setApiError(true);
      });
  };

  return (
    <Flex center={"md"} fill layout={1}>
      {submitted ? (
        <FormAlert
          severity="success"
          title="Tak for din henvendelse​"
          text="Vi kontakter dig i løbet af 3 hverdage for at udarbejde et uforpligtende og skræddersyet forsikringstilbud.​​"
        />
      ) : (
        <Formik
          enableReinitialize
          initialValues={{
            companyName: "",
            cvrNumber: "",
            name: "",
            phoneNumber: "",
            email: "",
          }}
          validationSchema={validationSchema()}
          onSubmit={(formData: FormData) => {
            sendFormData(formData);
          }}
        >
          <RenderForm isLoading={isLoading} />
        </Formik>
      )}
      {apiError && (
        <FormAlert
          severity="error"
          text="Der skete en fejl ved indsendelse. Prøv venligst igen senere"
          title="Der skete en fejl."
        />
      )}
    </Flex>
  );
};

interface RenderProps {
  isLoading: boolean;
}

const RenderForm: FunctionComponent<RenderProps> = ({ isLoading }) => {
  const { handleSubmit, handleBlur, setFieldValue, touched, errors, values } =
    useFormikContext<FormData>();

  return (
    <form onSubmit={handleSubmit}>
      <Flex layout={1}>
        <Title size={4}>Bestil tilbud</Title>
        <FormInput
          id="companyName"
          labelText="Virksomhedens navn"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setFieldValue("companyName", event.target.value);
          }}
          onBlur={handleBlur}
          invalid={!!(touched.companyName && errors.companyName)}
          errorText={errors.companyName}
          value={values.companyName}
        />
        <FormInput
          id="cvrNumber"
          labelText="CVR-nummer *"
          name="cvrNumber"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setFieldValue("cvrNumber", event.target.value);
          }}
          onBlur={handleBlur}
          invalid={!!(touched.cvrNumber && errors.cvrNumber)}
          errorText={errors.cvrNumber}
          value={values.cvrNumber}
        />
        <FormInput
          id="name"
          labelText="Navn"
          name="name"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setFieldValue("name", event.target.value);
          }}
          onBlur={handleBlur}
          invalid={!!(touched.name && errors.name)}
          errorText={errors.name}
          value={values.name}
        />
        <FormInput
          id="phoneNumber"
          labelText="Dit telefonnummer *"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setFieldValue("phoneNumber", event.target.value);
          }}
          onBlur={handleBlur}
          invalid={!!(touched.phoneNumber && errors.phoneNumber)}
          errorText={errors.phoneNumber}
          value={values.phoneNumber}
        />
        <FormInput
          id="email"
          type={"email"}
          labelText="Din mail *"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setFieldValue("email", event.target.value);
          }}
          onBlur={handleBlur}
          invalid={!!(touched.email && errors.email)}
          errorText={errors.email}
          value={values.email}
        />
        <Button loading={isLoading} type="submit" flexible>
          Bestil tilbud
        </Button>
      </Flex>
    </form>
  );
};

export default OrderOfferDIByggeri;
